import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./css/Checkout.css"

const EcommerceCheckout = ({ cartItems }) => {
  const [formData, setFormData] = useState({
    cedula: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    vin: "",
    mileage: "",
    street: "",
    zipCode: "",
    state: "",
    country: "",
  });

  // Ejemplo de lista de elementos con precios
  const items = [""];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulario enviado:", formData);
  };

  // Calcular el precio total de todos los ítems
  const totalPrice = cartItems.reduce((total, item) => total + item.quantity * item.price, 0);

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <h2 className="text-center ">Datos de contacto</h2>
      </Row>
      <Row>

        {/* Sección 1: Datos Personales */}

        <Col md={6}>
          <div className="mb-4 p-3 border rounded bg-light">
            <h4 className="mb-3">Datos Personales</h4>
            <Row className="mb-3">
              <Col md={12}>
                <label htmlFor="cedula" className="form-label">
                  Cedula/Ruc <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="text"
                  id="cedula"
                  name="cedula"
                  className="form-control"
                  placeholder="Ingresa tu numero de identidad"
                  value={formData.cedula}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <label htmlFor="firstName" className="form-label">
                  Nombre <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  className="form-control"
                  placeholder="Ingresa tu nombre"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6}>
                <label htmlFor="lastName" className="form-label">
                  Apellido <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  className="form-control"
                  placeholder="Ingresa tu apellido"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <label htmlFor="email" className="form-label">
                  Correo Electrónico <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Ingresa tu correo"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6}>
                <label htmlFor="phoneNumber" className="form-label">
                  Teléfono <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  className="form-control"
                  placeholder="Ingresa tu teléfono"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
          </div>
        </Col>

        {/* Sección 2: Datos de Facturacion */}
        <Col md={6}>
          <div className="mb-4 p-3 border rounded bg-light">
            <h4 className="mb-3">Datos de Facturación</h4>
            <Row className="mb-3">
              <Col md={6}>
                <label htmlFor="street" className="form-label">
                  Dirección <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="text"
                  id="street"
                  name="street"
                  className="form-control"
                  placeholder="Calle principal"
                  value={formData.street}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6}>
                <label htmlFor="zipCode" className="form-label">
                  Código Postal <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="text"
                  id="zipCode"
                  name="zipCode"
                  className="form-control"
                  placeholder="Ejemplo: 170505"
                  value={formData.zipCode}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <label htmlFor="state" className="form-label">
                  Provincia <span className="text-danger">(Requerido)</span>
                </label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  className="form-control"
                  placeholder="Pichincha"
                  value={formData.state}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6}>
                <label htmlFor="country" className="form-label">
                  País
                </label>
                <input
                  type="text"
                  id="country"
                  name="country"
                  className="form-control"
                  value={"Ecuador"}
                  readOnly
                  required
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="p-3 mb-4 border rounded bg-light">
          <h4 className="mb-3">Resumen del Pedido</h4>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Producto</th>
                <th scope="col" class="text-right">Cantidad</th>
                <th scope="col" class="text-right">Precio</th>
                <th scope="col" class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
            {cartItems.map((item, index) => (
              <tr
                key={index}
              >
                <td>{item.name}</td>
                <td class="text-right">{item.quantity}</td>
                <td class="text-right">${item.price}</td>
                <td class="text-right">${(item.quantity * item.price).toFixed(2)}</td>
              </tr>
            ))}
              <tr>
                <th scope="row">Total</th>
                <td></td>
                <td></td>
                <td className="text-success text-right">${totalPrice.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
          <button className="btn btn-payment w-100">Continuar con el Pago</button>
        </Col>
      </Row>
    </Container>
  );
};

export default EcommerceCheckout;
